import { Injectable } from '@angular/core';
import { CusHttp } from '../core/services/CusHttp';
import { URLSearchParams } from '@angular/http';
//热门、推荐课程、适合你的课程
const COU_HOT = "v1/course-package/hotcourse?";
//期望岗位
const HopeJobURL = 'v1/public/hope-category';

// 友情链接接口
const FRIENDSHIP = 'v1/public/links';

//获取意见返回信息
const FEEDBACKS = "v1/feedbacks";
@Injectable()
export class SharedService {

  constructor(
    private _http: CusHttp,
  ) { }


  //热门、推荐课程
  getHotCourse(id?: number, num?: any) {
    let a = new URLSearchParams;
    id && a.append('direction_id', id.toString());
    num && a.append('num', num);

    return this._http.get(`${COU_HOT}` + a.toString());
  }

  //// 友情链接接口
  Friendship() {
    return this._http.get(FRIENDSHIP);

  }

  //期望岗位
  getHopeJobData() {
    return this._http.get(HopeJobURL);
  }

  //获取意见返回信息
  getFeedback(formValue: any) {
    let params = new FormData();
    for (let i in formValue) {
      params.append(i, formValue[i]);
    }
    return this._http.post(`${FEEDBACKS}`, params);
  }

}



// WEBPACK FOOTER //
// /data/wwwroot/xzhipin/app-client/src/app/shared/shared.service.ts